export default function ({ req, redirect }) {
    if (req?.url.includes('//') === true) {
        return redirect(302, req.url.replaceAll(/\/+/g, '/'))
    }
}
